module.exports = __webpack_public_path__ + "g.no2.54b6697c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/g.no2.jpg
// module id = s0DU
// module chunks = 0